import { z } from "zod";
export const loginBreakpointSchema = z.enum(["base", "tablet", "mobile"]);
export const loginAvatarTransformSchema = z.object({
    x: z.number().min(0).max(1),
    y: z.number().min(0).max(1),
    scale: z.number().min(0.2).max(1.4)
});
export const loginAvatarConfigurationSchema = z.object({
    id: z.string().min(1).max(128),
    label: z.string().trim().min(1).max(100),
    userId: z.string().min(1).max(128).nullable(),
    isActive: z.boolean(),
    zIndex: z.number().int().min(0).max(500),
    base: loginAvatarTransformSchema,
    tablet: loginAvatarTransformSchema.nullable(),
    mobile: loginAvatarTransformSchema.nullable()
});
export const updateLoginCompositionSchema = z.object({
    expectedVersion: z.number().int().nonnegative(),
    avatars: z.array(loginAvatarConfigurationSchema).max(60)
});
export const loginAvatarHeightSchema = z.object({
    heightCm: z.number().min(120).max(230)
});
